import React from "react";
import { CATEGORY_ICONS } from "@/lib/constants";

export default function CategoryBadge({ category, size = "md" }) {
  const Icon = CATEGORY_ICONS[category] || CATEGORY_ICONS.other_services;
  const dims = size === "sm" ? "h-9 w-9" : size === "lg" ? "h-14 w-14" : "h-11 w-11";
  return (
    <div className={`${dims} rounded-full bg-emerald-50 text-emerald-600 grid place-items-center shrink-0`}>
      <Icon className={size === "sm" ? "h-4 w-4" : "h-5 w-5"} strokeWidth={2.2} />
    </div>
  );
}
